import { render, staticRenderFns } from "./FormFarmer.vue?vue&type=template&id=70e6992a&lang=html&"
import script from "./FormFarmer.vue?vue&type=script&lang=js&"
export * from "./FormFarmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormFarmer.vue"
export default component.exports